import { createContext, useContext } from "react";

import { useStore } from "@/store";

import type { NodeTheme } from "@/components/expression/theme/types";

export const MathThemeContext = createContext<NodeTheme | undefined>(undefined);

export function useMathTheme(): NodeTheme {
  const context = useContext(MathThemeContext);
  const {
    userSettings: { mathTheme: theme },
  } = useStore();

  /**
   * Note: We don't wrap the entire application in MathThemeProvider.
   * Instead, we get the current theme from the root store.
   * This allows us to render parts of the application in different themes (e.g., previews).
   */
  if (!context) {
    return theme;
  }

  return context;
}
